import LinearProgress from '@mui/material/LinearProgress';
import {styled} from '@mui/material/styles';

const ProgressBar = ({barWidth}) => {
  return <LinearProgressBar color="info" style={{width: barWidth, height: 2}} />;
};

const LinearProgressBar = styled(LinearProgress)(({theme}) => ({
  backgroundColor: theme.palette.background.default,
  root: {
    height: theme.spacing(0.1),
    backgroundColor: theme.palette.background.paper,
    '& > * + *': {
      marginTop: theme.spacing(0),
    },
  },
}));

export default ProgressBar;
